/*
 * @Author: zyy
 * @Date: 2022-11-17 09:36:39
 * @LastEditors: zyy
 * @LastEditTime: 2022-11-17 16:32:52
 * @Description: default
 */


import shopRequests from "../shopRequest";
import Qs from 'qs'
export default {
    // 订单列表
    list(params) {
        return shopRequests.get('/shop/addons/shopro/admin_api_dispatch/index', {
            params,
        })
    },
    add(params) {
        return shopRequests.post('/shop/addons/shopro/admin_api_dispatch/add', params)
    },
    edit(params) {
        return shopRequests.post('/shop/addons/shopro/admin_api_dispatch/edit', params)
    },
    del(id) {
        return shopRequests.post('/shop/addons/shopro/admin_api_dispatch/del', {
            id
        })
    }

}